module.exports = __webpack_public_path__ + "img/sell-money-bag.8b9ad257.svg";